import React, { useRef } from 'react';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { Upload, Delete } from '@mui/icons-material';
import PropTypes from 'prop-types';

export const AvatarUploader = ({
  avatar,
  placeholder,
  onSubmitAvatar,
  onDeleteAvatar,
  imageStyle,
  showControlsBelow,
}) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onSubmitAvatar({ file, name: file.name });
      // Reset the input to allow re-uploading the same file
      event.target.value = null;
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* Image or Placeholder */}
      <Box
        sx={{
          width: '100%',
          height: showControlsBelow ? '80%' : '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {avatar ? (
          <img
            src={avatar}
            alt="Uploaded avatar"
            style={{ ...imageStyle, width: '100%', height: '100%' }}
          />
        ) : (
          placeholder
        )}
      </Box>

      {/* Controls */}
      <Box
        sx={{
          display: 'flex',
          gap: 1,
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          mt: showControlsBelow ? 1 : 0,
          position: showControlsBelow ? 'static' : 'absolute',
          bottom: showControlsBelow ? 'auto' : 10,
        }}
      >
        <input
          type="file"
          accept="image/png"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        <Tooltip title={avatar ? "Replace Image" : "Upload Image"}>
          <Button
            variant="contained"
            size="small"
            startIcon={<Upload />}
            onClick={handleUploadClick}
          >
            {avatar ? 'Replace' : 'Upload'}
          </Button>
        </Tooltip>
        {avatar && (
          <Tooltip title="Delete Image">
            <IconButton
              color="error"
              onClick={onDeleteAvatar}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

AvatarUploader.propTypes = {
  avatar: PropTypes.string,
  placeholder: PropTypes.node,
  onSubmitAvatar: PropTypes.func.isRequired,
  onDeleteAvatar: PropTypes.func.isRequired,
  imageStyle: PropTypes.object,
  showControlsBelow: PropTypes.bool,
};

AvatarUploader.defaultProps = {
  avatar: null,
  placeholder: null,
  imageStyle: {},
  showControlsBelow: false,
};

